import {ModelListSelect} from 'vue-search-select';
import Pagination from "../../components/Pagination";
export default {
    name: "buses_index_component",
    components: {
        ModelListSelect,
        Pagination
    },
    data() {
        return {
            buses: [],
            transporters: [],
            transporter_id: null,
            searchKeyword: null,
            loading_states : {
                list: false,
            },
            page: 1,
            links: {}
        }
    },
    methods: {
        searching() {
            this.page = 1;
            this.loadBuses()
        },
        deleteItem(item) {
            let indx = this.buses.indexOf(item);
            if (indx >= 0 && confirm('Вы действительно хотите удалить?')) {
                this.$api.delete('buses.delete', item.id).then(res => {
                    if (!res.errors) {
                        this.buses.splice(indx, 1);
                    }
                })
            }
        },
        loadTransporters() {
            let searchData = {};
            this.$api.get('transporters.index', searchData).then(({data}) => {
                this.transporters = data;
            });
        },
        loadBuses() {
            this.loading_states.list = true;
            let postData = {page: this.page};
            if (this.transporter_id !== null) {
                postData.transporter_id = this.transporter_id;
            }
            if (this.searchKeyword !== null) {
                postData.searchKeyword = this.searchKeyword;
            }
            this.$api.post('buses.transporter-buses', postData)
                .then(response => {
                    this.buses = response.data;
                    this.links = response.links
                }).finally(() => {
                this.loading_states.list = false;

            });
        },
        changeBusStatus(bus){
            if(confirm(this.i18n('Do you really want to change the status?'))){
                try{
                    this.$api.post('buses.change-status', {bus: bus})
                        .then(response => {
                            let status = response.data.status;
                            this.buses.filter(item => {
                                if(item.id == bus){
                                    item.status = status;
                                    return true;
                                }
                            });

                            this.$store.commit("successNotifyByText", this.i18n('Changed status'))


                        }).catch(error => {
                        this.$store.commit("successNotifyByText", this.i18n('Failed to change'));
                        console.log(error)
                    });
                }catch (e) {
                    this.$store.commit("successNotifyByText", this.i18n('Failed to change'))
                }
            }


        }
    },
    beforeRouteUpdate(to, from, next) {
        let page = to.params.page;
        if (page) {
            this.page = page;
            this.loadBuses();
        }
        next();
    },
    created() {
        this.page = this.$route.params.page;
        this.loadTransporters();
        this.loadBuses();
    },
    watch: {
        transporter_id: function () {
            this.loadBuses();
        },
        searchKeyword: function(){
            setTimeout(this.searching(), 100)

        }
    },
}
